<template>
    <div>
        <el-dialog
            :visible.sync="dialog.isDialog"
            width="30%"
            custom-class="loadingDialogComplete"
            center>
            <span slot="title" style="font-size:22px;">
                Update Status
            </span>
            <div class="text-center">
                <el-row>
                    <el-col :span="24">
                        <el-select v-model="selectId" placeholder="Select" style="width:300px;">
                            <el-option
                                v-for="item in list"
                                :key="item.id"
                                :label="item.th"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="24" style="margin-top:20px;">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 4}"
                            placeholder="Note"
                            style="width:300px;"
                            v-model="note">
                        </el-input>
                    </el-col>
                </el-row>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialog.isDialog = false">Cancel</el-button>
                <el-button type="primary" @click="onSave">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'DialogComplete',
    props: {
        dialog: {
            type: Object,
            default: () => {
                return {
                    isDialog: false,
                    data: {
                        oldStatus: null,
                        orderNumber: null,
                        orderId: null
                    }
                }
            }
        }
    },
    data () {
        return {
            selectId: null,
            list: [
                { id: 7, en: 'Return', th: 'ถูกตีกลับ' },
                { id: 8, en: 'Delivered', th: 'ส่งสำเร็จแล้ว' }
            ],
            note: ''
        }
    },
    // watch: {
    //     'dialog.isDialog' (val) {
    //         console.log('dialog', val)
    //     }
    // },
    methods: {
        async onSave () {
            if (this.selectId) {
                let loadingAddUser = this.$loading({
                    target: '.loadingDialogComplete',
                    text: 'กำลังบันทึก...'
                })

                let param = {
                    orderNumber: this.dialog.data.orderNumber,
                    status: this.selectId,
                    oldStatus: this.dialog.data.oldStatus,
                    adminEmail: this.$store.get('user/objUser').email,
                    note: this.note
                }

                try {
                    let res = await fgApi.order.changeStatusLogOrder(param)
                    if (res.success) {
                        this.$notify({
                            title: 'Success',
                            message: 'Update successful',
                            type: 'success'
                        })
                        this.dialog.isDialog = false
                        this.$emit('onSuccess', this.dialog.data.orderId)
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: res.message
                        })
                    }
                } catch (error) {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    })
                }
                loadingAddUser.close()
            } else {
                this.$notify({
                    title: 'Warning',
                    message: 'กรุณาเลือกสถานะ',
                    type: 'warning'
                })
            }
        }
    }
}
</script>

<style>

</style>
